import React from 'react';
import { Button, Result } from 'antd';

const ErrorServer: React.FC = () => (
  <Result
    status="500"
    title="500"
    subTitle="Servidores no disponibles"    
  />
);

export default ErrorServer;